const oldPortalUrl = 'https://gulf-manage.fieldassist.io/';
const dashboardAPIUrl = 'https://fadashboardv2-gulf.azurewebsites.net/';
//const dashboardAPIUrl = 'https://localhost:5001/';


export {
    oldPortalUrl,
    dashboardAPIUrl,
}